import { GetAllBones, RgCreate, DefaultCorridor } from "@project-rouge/rg-core";
import { V3toVector3, SignedAngle, TranslateAndRotate, CopyAcrossFloors, RgShallowClone } from "@project-rouge/rg-three";
import { Vector3 } from "three";
import { TendonToVector } from "./index57.js";
const right = new Vector3(1, 0, 0);
const AddCorridorsToAnatomy = (building, dataset) => {
  if (!building.data.anatomy)
    return;
  const bones = GetAllBones(building.data.anatomy);
  for (const b of bones) {
    const corridor = RgCreate({
      ...DefaultCorridor,
      size: [0, dataset.aggConfig.f2fHeight, dataset.aggConfig.corridorWidth],
      anchor: [0, 0, 0.5],
      data: { level: -1, levelId: "", tendonID: b.tendon.id }
    }, dataset.rvData);
    const t = b.tendon;
    const tPosStart = V3toVector3(t.points[0]);
    const tLength = TendonToVector(t);
    corridor.size[0] = tLength.length();
    const angle = SignedAngle(right, tLength);
    TranslateAndRotate([corridor], angle, tPosStart);
    building.children = building.children.concat(CopyAcrossFloors({
      list: [corridor].map(RgShallowClone),
      floors: b.floors,
      height: dataset.aggConfig.f2fHeight,
      yStart: 0
    }));
  }
};
export {
  AddCorridorsToAnatomy
};
//# sourceMappingURL=index2.js.map
